/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 数据字典路由配置
 */

const Layout = () => import('@/views/index/index.vue')
// 应用管理页面
const appManage = () => import('@/views/poc-app/index.vue')
export default // 应用管理
// 应用管理页面
{
  path: '/application',
  // component: layout,
  // component: import('@/views/index/index.vue'),
  redirect: '/application/index',
  component: Layout,
  // 重定向
  children: [
    // 应用管理
    {
      path: 'index',
      name: 'Index',
      // component: import('@/components/layout/index.vue'),
      component: appManage,
      meta: {
        name: '应用管理',
        context: 'application/index',
        type: 'INNER_APP'
      }
    }
  ]
}
